import { css } from '@genesislcap/web-core';

export const UserActivityStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }
`;

